class ContentPage extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const nav = this.querySelector('.content-page__nav');
    if (!nav) return;

    const headings = Array.from(this.querySelectorAll('[data-anchor-label]'));
    if (headings.length === 0) {
      nav.hidden = true;
      return;
    }

    this.#buildNav(nav, headings);
    this.#observeHeadings(nav, headings);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #buildNav(nav, headings) {
    const list = document.createElement('ul');
    list.className = 'content-page__nav-list';

    headings.forEach(heading => {
      const li = document.createElement('li');
      li.className = 'content-page__nav-item';
      const a = document.createElement('a');
      a.className = 'content-page__nav-link';
      a.href = `#${heading.id}`;
      a.textContent = heading.dataset.anchorLabel;
      a.addEventListener('click', e => {
        e.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    nav.appendChild(list);
  }

  #observeHeadings(nav, headings) {
    this.#observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const link = nav.querySelector(`a[href="#${entry.target.id}"]`);
        if (link) link.classList.toggle('is-active', entry.isIntersecting);
      });
    }, { rootMargin: '-5% 0px -85% 0px', threshold: 0 });

    headings.forEach(h => this.#observer.observe(h));
  }
}

customElements.define('content-page', ContentPage);
